import Parse from "parse";

Parse.initialize("asew-klima");
Parse.serverURL = "https://parse-asew-klima.prod.openinc.de/parse";
